import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs from "../../../app/lang/langs";
import { InputField } from "../../inputs/InputField";
import { DynamicButton } from "../../buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import moment from "moment";
import { markNewsAsRead, setNewsList } from "../../../containers/dashboard/dashboardSlice";


export default function NewsModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [updatedItem, setUpdatedItem] = useState(props.selectedNews)

    const userId = useSelector((state) => state.login.userId)
    const newsList = useSelector((state) => state.dashboard.news)

    const mobile = isMobile === 2

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }

    useEffect(() => {
        setUpdatedItem({
            ...props.selectedNews
        })
        if (props.selectedNews && !props.selectedNews.seen && props.selectedNews.id) {
            handleMarkAsRead()
        }
    }, [props.selectedNews])

    const handleMarkAsRead = async () => {
        let results = await dispatch(markNewsAsRead({
            newsId: props.selectedNews.id,
            userId: userId
        })).unwrap()
        if (results) {
            let updatedNewsList = newsList.map(news => {
                if (news.id === props.selectedNews.id) {
                    return { ...news, seen: moment().format("YYYY-MM-DD HH:mm:ss") };
                }
                return news;
            });
            dispatch(setNewsList(updatedNewsList))
        }
    }

    const visibleFields = [
        { key: "title", type: "string", disabled: true },
        { key: "message", type: "text", disabled: true, auto: true },
        { key: "created_by", type: "string", disabled: true },
        { key: "created_at", type: "date:time", disabled: true },
    ]

    const handleSave = async () => {

    }

    const footer = () => {
        if (JSON.stringify(props.selectedNews) != JSON.stringify(updatedItem))
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={mobile ? 8 : 2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="Save" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
    }

    return (
        <>
            <Dialog
                visible={props.selectedNews}
                className={mobile ? "news-modal-mobile" : ""}
                style={{
                    width: mobile ? "100%" : "50%",
                    maxHeight: mobile ? "85vh" : undefined,
                    borderRadius: mobile ? "16px 16px 0 0" : "18px",
                    overflow: "hidden",
                    boxShadow: "0 8px 32px rgba(255, 144, 21, 0.10), 0 2px 12px rgba(0, 0, 0, 0.08)",
                    border: mobile ? "none" : "1px solid rgba(255, 144, 21, 0.12)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    background: "rgba(255, 255, 255, 0.88)",
                    ...(mobile ? { margin: 0, bottom: 0, position: "fixed", left: 0, right: 0, top: "auto" } : {}),
                }}
                contentStyle={{
                    padding: mobile ? "16px" : "24px 28px",
                    background: "transparent",
                    overflow: mobile ? "auto" : undefined,
                }}
                headerStyle={{
                    padding: mobile ? "16px 16px 10px" : "20px 28px 12px",
                    background: "linear-gradient(135deg, rgba(255, 144, 21, 0.06) 0%, rgba(255, 193, 0, 0.04) 100%)",
                    borderBottom: "1px solid rgba(255, 144, 21, 0.10)",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                    color: "#2d2a26",
                    fontSize: "1.1rem",
                }}
                onHide={() => {
                    props.onHide()
                }}
                header={<Langs str="Actualité" />}
                draggable={false}
                dismissableMask={false}
                footer={footer}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: mobile ? "12px" : "16px",
                    animation: mobile
                        ? "newsModalSlideUp 300ms cubic-bezier(0.4, 0, 0.2, 1) both"
                        : "newsViewModalFadeIn 280ms cubic-bezier(0.4, 0, 0.2, 1) both",
                }}>
                    {visibleFields.map(field => <InputField field={field}
                        onChange={(e) => handleFieldChange(e, field)}
                        value={updatedItem && updatedItem[field.key]} />
                    )}
                </div>
            </Dialog>
            <style>{`
                @keyframes newsViewModalFadeIn {
                    from { opacity: 0; transform: translateY(8px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes newsModalSlideUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .news-modal-mobile input,
                .news-modal-mobile textarea {
                    font-size: 16px !important;
                }
                .news-modal-mobile .p-dialog-header-icons .p-dialog-header-icon {
                    width: 44px !important;
                    height: 44px !important;
                    min-width: 44px;
                    min-height: 44px;
                }
                .news-modal-mobile + .p-dialog-mask,
                .news-modal-mobile.p-dialog + .p-component-overlay {
                    backdrop-filter: blur(6px);
                    -webkit-backdrop-filter: blur(6px);
                }
            `}</style>
        </>
    )
}
